import apiClient from './apiClient';

// ============================================================
// PW0308 - 系統使用記錄 API types and client
// ============================================================

export interface PW0308ReportRow {
  f008_01: string;  // 使用者代號
  f008_02: string;  // 使用日期
  f008_03: string;  // 程式代號
  f008_10: string;  // 程式名稱
  f008_11: string;  // 登入時間
  f008_12: string;  // 登出時間
  f008_13: string;  // 備註
  f008_14: string;  // 其他資訊
}

export interface PW0308ReportResponse {
  items: PW0308ReportRow[];
  total: number;
}

export interface PW0308ReportParams {
  startUser?: string;
  endUser?: string;
  startDate?: string;
  endDate?: string;
}

export const pw0308Api = {
  async getReport(params: PW0308ReportParams): Promise<PW0308ReportResponse> {
    const query: Record<string, string> = {};
    if (params.startUser)  query['startUser']  = params.startUser;
    if (params.endUser)    query['endUser']    = params.endUser;
    if (params.startDate)  query['startDate']  = params.startDate;
    if (params.endDate)    query['endDate']    = params.endDate;
    return (await apiClient.get('/api/pw0308/report', { params: query })).data;
  },
};
